<div class="outer-container">
  <div fxLayout="row" fxLayoutAlign="space-around">
    <div class="assignment-container" fxLayout="row" fxLayout.lt-sm="column">
      <div fxFlex="80" class="border info-container" fxLayout="column" fxLayoutAlign="space-between">
        <div class="name">
          {{ assignmentName }}
        </div>
        <div class="sub-heading" fxLayout="row">
          <div class="info-key">
            Students Enrolled
          </div>
          <div>
            : &nbsp; {{ curriculumDataReceived ? (assignment.AssignedStudentAttempts ? assignment.AssignedStudentAttempts.length : '--') : '--' }}
          </div>
        </div>
        <div fxLayout="row">
          <div class="assignment-id" *ngFor="let assignment of Object.keys(assignmentsObject)"
            (click)="navigateToID(assignmentsObject[assignment][0].AssignmentID)">
            {{ assignmentsObject[assignment][0].StartDate }}
          </div>
        </div>
      </div> 
      
      <div class="border info-container" fxLayout="column" fxLayoutAlign="space-around">
        <button class="outline-link-btn btn-white" routerLink="/ELearning/Class/{{classID}}">Gradebook</button>
        <a href="{{assignment?.ClassDetails.ClassHomePageUrl}}"><button class="outline-link-btn btn-white">Classroom Homepage</button>
        </a>
        <a href="javascript:void(0)"  *ngIf="showCreateAssignments" role="button" (click)="redirectToAssignedClass()"><button class="outline-link-btn btn-white">Add New Assignment</button>
        </a>
        
      </div>

      <div class="info-container" fxLayout="column" fxLayoutAlign="space-around">
        <button class="outline-btn btn-white" (click)="onReleaseAll()">
          Release All
        </button>
        <button class="outline-btn btn-white" (click)="onUnassignAll()">
          Unassign All
        </button>
    </div>
  </div>
</div>

  <div fxLayout="row" fxLayoutAlign="space-between">
    <div class="sub-title">
      Students
    </div>
    <div fxLayout="row"  *ngIf="curriculumDataReceived && assignment.AssignedStudentAttempts">
      <div>
        <span class="expand-all" (click)="onExpandAll()">
          Expand All
        </span>
        <span class="collapse-all" (click)="onCollapseAll()">
          Collapse All
        </span>
      </div>
      <div>
        <span>(</span>
        <span>
          {{ curriculumDataReceived ? filteredStudents?.length : '--' }}
        </span>
        <span>
          / {{ curriculumDataReceived ? assignment.AssignedStudentAttempts?.length : '--' }}
        </span>
        <span>)</span>
      </div>
      <app-filter class="filter-component" [route]="'assignment'"></app-filter>
    </div>
  </div>

  <div *ngIf="!curriculumDataReceived" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>

  <div *ngIf="curriculumDataReceived">
    
    <div class="no-data-container" *ngIf="assignment?.AssignedStudentAttempts && !filteredStudents?.length">
      <div class="heading">
        We couldn't find any Students matching the current Filtering options.
      </div>
      <div class="sub-heading">
        Change the Filter options to view Students.
      </div>
    </div>

    <div *ngIf="!assignment.AssignedStudentAttempts?.length" class="heading">
      There are no Students enrolled in this Assignment.
    </div>

    <mat-accordion [multi]="true" #accordion="matAccordion">
      <div *ngFor="let assignment of Object.keys(assignmentsObject)">
        <app-assignment-panel 
        [assignment]="assignmentsObject[assignment]" 
        [classID]="classID"
        [lessonName]="assignmentName"
        ></app-assignment-panel>
      </div>
    </mat-accordion>
  </div>
</div>
